interface GoatCounter {
   count?: (options: { path: string; title?: string; event?: boolean }) => void;
}

declare global {
   interface Window {
      goatcounter?: GoatCounter;
   }
}

export function trackEvent(name: string) {
   window.goatcounter?.count?.({ path: name, title: name, event: true });
}

export function trackPageView(path: string) {
   window.goatcounter?.count?.({ path });
}

const errorsTracked = new Set<string>();

function trackError(message: string, fileName: string, lineNumber: number) {
   const location = fileName ? ` (${fileName.split("/").pop()}:${lineNumber})` : "";
   const name = `error: ${message.slice(0, 200)}${location}`;
   if (errorsTracked.has(name)) return;
   errorsTracked.add(name);
   trackEvent(name);
}

export function trackUncaughtErrors() {
   window.addEventListener("error", (event) => {
      trackError(event.message || "Unknown error", event.filename, event.lineno);
   });
   window.addEventListener("unhandledrejection", (event) => {
      const reason = event.reason instanceof Error ? event.reason.message : `${event.reason}`;
      trackError(`Unhandled promise: ${reason}`, "", 0);
   });
}
